"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _validate = require("@/utils/validate");
var _selectCompay = _interopRequireDefault(require("../../../business/supplier/coupons/selectCompay.vue"));
var _throttle = _interopRequireDefault(require("@/utils/throttle"));
var customerOrderApi = _interopRequireWildcard(require("@/api/customerOrderApi.js"));
var fudouActiveApi = _interopRequireWildcard(require("@/api/fudouActiveApi.js"));
var _cardDetailApi = require("@/api/cardDetailApi");
var _api = require("@/views/marketing/coupon/api.js");
var suplierCouponsApi = _interopRequireWildcard(require("@/api/suplierCouponsApi.js"));
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  components: {
    SelectCompay: _selectCompay.default
  },
  data: function data() {
    return {
      initloading: false,
      loading: false,
      visible: false,
      orderNo: '',
      pram: {
        cardTimeRange: [],
        // 福卡有效期（开始和结束时间）
        cardValidStart: '',
        // 福卡有效期开始时间 - 新字段名
        cardValidEnd: '',
        // 福卡有效期结束时间 - 新字段名
        // 由于需求删除订单有效期为了避免后端有使用该字段直接设置一个永不过期字段
        orderTimeRange: ['2000-01-01 00:00:00', '2099-12-31 23:59:59'],
        // 订单有效期（开始和结束时间）
        orderValidStart: '2000-01-01 00:00:00',
        // 订单有效期开始时间 - 新字段名
        orderValidEnd: '2099-12-31 23:59:59',
        // 订单有效期结束时间 - 新字段名
        totalPrice: 0,
        // 确保初始化时设置为0
        innerCompanyName: '',
        // 初始化公司名称
        companyId: '',
        // 初始化公司ID（传给 SelectCompay）
        projectNumber: '',
        // 初始化项目编号
        type: 2,
        // 默认为用户自选类型
        couponPackages: [],
        // 初始化优惠券包数组为空数组
        salesUnitPrice: 0,
        // 销售单价
        salesPrice: 0,
        // 销售总价
        kamiType: 1,
        // 默认卡密类型为卡密绑定
        sendType: '',
        status: 1 // 订单状态，默认已下单
      },
      cardTypeOptions: [],
      //发卡类型
      details: {},
      cosotmerOption: [],
      // 归属客户
      mealOption: [],
      // 套餐
      brandOption: [],
      appOptions: [],
      // 小程序选项
      companyOptions: [],
      // 发放公司选项（新select）
      kamiTypeOptions: [{
        label: '卡密绑定',
        value: 1
      }, {
        label: '付款码实体卡',
        value: 2
      }],
      statusOptions: [{
        value: -1,
        label: '卡密生成中'
      }, {
        value: 0,
        label: '整单作废'
      }, {
        value: 1,
        label: '已下单'
      }, {
        value: 2,
        label: '已确认'
      }, {
        value: 3,
        label: '已生成订单'
      }],
      // 权益卡包相关数据
      packageOptions: [],
      // 权益卡包选项
      packagePage: 1,
      // 权益卡包分页
      packageLimit: 20,
      // 每页数量
      hasMorePackages: false,
      // 是否有更多数据
      packageKeyword: '',
      // 搜索关键词
      relatedCards: [],
      // 关联的卡片
      totalDistribution: 0,
      distributionWarningVisible: false,
      // 分配额度警告显示标志

      // 添加配置缓存，用于存储不同卡包的配置
      packageDistributionCache: {},
      // 格式: {packageId: {cardId: distributionValue}}
      originalPackageId: null,
      // 记录原始编辑的卡包ID
      originalFuConfig: null,
      // 记录原始编辑的配置

      // 优惠券包相关数据
      couponPackages: [],
      // 已选择的优惠券包
      couponPackageOptions: [],
      // 优惠券包选择选项
      couponPackagePage: 1,
      // 当前页码
      couponPackageLimit: 20,
      // 每页数量
      couponPackageTotal: 0,
      // 总数量
      couponPackageKeyword: '',
      // 搜索关键字
      couponPackageLoading: false // 加载状态
    };
  },
  props: {
    cardTypeList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  computed: {
    // 判断分配额度是否超出或不足福卡面值
    isDistributionExceeded: function isDistributionExceeded() {
      var price = parseFloat(this.pram.price) || 0;
      if (price <= 0) return false;
      return this.totalDistribution !== price;
    },
    // 判断是否为查看模式（status 不是 0 或 1 的情况）
    isViewMode: function isViewMode() {
      // 新增订单时 orderNo 为空或0，此时不是查看模式
      if (!this.orderNo) return false;
      // 编辑模式：status 为 0 或 1；查看模式：status 不是 0 或 1
      return ![0, 1].includes(this.details.status);
    },
    // 根据模式返回不同的状态选项
    currentStatusOptions: function currentStatusOptions() {
      // 新增订单或编辑模式（status 为 0 或 1）：只显示"已下单"和"已确认"
      if (!this.orderNo || [0, 1].includes(this.details.status)) {
        return [{
          value: 1,
          label: '已下单'
        }
        // { value: 2, label: '已确认' }
        ];
      }
      // 查看模式：显示完整的状态列表
      return this.statusOptions;
    },
    projectNumberRules: function projectNumberRules() {
      if (Number(this.pram.sendType) === 4) {
        return [{
          required: true,
          message: '请填写项目编号',
          trigger: ['blur', 'change']
        }];
      }
      return [];
    }
  },
  mounted: function mounted() {
    this.searchBrand('');
    this.getAppList();
    // 初始加载优惠券包列表
    this.searchCouponPackages(true);
  },
  watch: {
    // 监听福卡面值变化
    'pram.price': function pramPrice(newValue) {
      // 当面值变化且订单类型为权益卡包时，自动平均分配
      if (this.pram.type === 3 && this.relatedCards.length > 0) {
        this.distributeValueEvenly();
      }
    },
    'pram.sendType': function pramSendType(val) {
      var _this = this;
      if (Number(val) !== 4 && this.$refs.pram) {
        this.$nextTick(function () {
          _this.$refs.pram.clearValidate('projectNumber');
        });
      }
    },
    cardTypeList: {
      handler: function handler(val) {
        console.log('接收到发卡类型列表:', val);
        this.cardTypeOptions = val || [];
      },
      immediate: true
    }
  },
  methods: {
    throttle: _throttle.default,
    initOpen: function initOpen(orderNo) {
      var _this2 = this;
      this.orderNo = orderNo;
      this.pram = {
        cardTimeRange: [],
        // 初始化福卡有效期
        cardValidStart: '',
        cardValidEnd: '',
        // 订单有效期使用一个“几乎永不过期”的固定区间
        orderTimeRange: ['2000-01-01 00:00:00', '2099-12-31 23:59:59'],
        // 初始化订单有效期
        orderValidStart: '2000-01-01 00:00:00',
        orderValidEnd: '2099-12-31 23:59:59',
        totalPrice: 0,
        // 确保初始化时设置为0
        innerCompanyName: '',
        // 初始化公司ID
        projectNumber: '',
        // 初始化项目编号
        type: 2,
        // 默认为用户自选类型
        couponPackages: [],
        // 初始化优惠券包数组为空数组
        salesUnitPrice: 0,
        // 销售单价
        salesPrice: 0,
        // 销售总价
        kamiType: 1,
        // 默认卡密类型为卡密绑定
        sendType: '',
        status: 1 // 订单状态默认已下单
      };
      // 新建订单时，默认将福卡有效期设置为“当前时间起 3 年”
      if (!orderNo) {
        this.setDefaultCardTimeRange();
      }
      this.details = {};
      this.packageDistributionCache = {}; // 清空缓存
      this.originalPackageId = null;
      this.originalFuConfig = null;

      // 重置优惠券包相关数据
      this.couponPackageOptions = [];
      this.couponPackagePage = 1;
      this.couponPackageKeyword = '';
      this.couponPackageTotal = 0;
      this.initAll();
      this.visible = true;

      // 无论是否有orderNo，都加载优惠券包列表
      this.searchCouponPackages(true);
      if (!this.orderNo) return;
      this.initloading = true;
      customerOrderApi.getOrderDetail(orderNo).then(function () {
        var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var _ref = res || {},
          id = _ref.id,
          startTime = _ref.startTime,
          endTime = _ref.endTime,
          orderValidStart = _ref.orderValidStart,
          orderValidEnd = _ref.orderValidEnd,
          innerCompanyName = _ref.innerCompanyName,
          companyName = _ref.companyName,
          projectNumber = _ref.projectNumber,
          comboId = _ref.comboId,
          comboName = _ref.comboName,
          cardStartTime = _ref.cardStartTime,
          cardEndTime = _ref.cardEndTime,
          cardValidStart = _ref.cardValidStart,
          cardValidEnd = _ref.cardValidEnd,
          dueTime = _ref.dueTime,
          fuPackageId = _ref.fuPackageId,
          fuConfig = _ref.fuConfig,
          couponPackages = _ref.couponPackages,
          salesPrice = _ref.salesPrice;

        // 调试：查看原始数据中的项目编号和公司信息
        console.log('原始订单数据项目编号:', projectNumber);
        console.log('原始订单数据公司ID:', innerCompanyName);
        console.log('原始订单数据公司名称:', companyName);

        // 调试：查看优惠券包原始数据
        console.log('原始优惠券包数据:', couponPackages);

        // 提前处理优惠券包数据，确保是ID数组
        var processedCouponPackages = _this2.processCouponPackages(couponPackages);
        console.log('处理后的优惠券包ID列表:', processedCouponPackages);

        // 处理基础数据
        _this2.pram = _objectSpread(_objectSpread({}, res), {}, {
          orderTimeRange: orderValidStart && orderValidEnd ? [orderValidStart, orderValidEnd] : startTime && endTime ? [startTime, endTime] : [],
          orderValidStart: orderValidStart || startTime || '',
          orderValidEnd: orderValidEnd || endTime || '',
          projectNumber: projectNumber || '',
          salesPrice: salesPrice || 0,
          // Add salesPrice here
          innerCompanyName: innerCompanyName,
          cardTimeRange: cardValidStart && cardValidEnd ? [cardValidStart, cardValidEnd] : cardStartTime && cardEndTime ? [cardStartTime, cardEndTime] : dueTime ? [new Date().toISOString().split('T')[0] + ' 00:00:00', dueTime] : [],
          cardValidStart: cardValidStart || cardStartTime || (dueTime ? new Date().toISOString().split('T')[0] + ' 00:00:00' : ''),
          cardValidEnd: cardValidEnd || cardEndTime || dueTime || '',
          comboId: comboId && comboName ? "".concat(comboId, "_").concat(comboName) : '',
          id: id || orderNo,
          status: res.status !== undefined && res.status !== null ? res.status : 1,
          // 设置优惠券包（确保是ID数组）
          couponPackages: processedCouponPackages
        });
        console.log('获取到的订单数据:', JSON.stringify(_this2.pram));

        // 权益卡包类型特殊处理
        if (_this2.pram.type === 3 && fuPackageId) {
          _this2.pram.packageId = fuPackageId;
          _this2.originalPackageId = fuPackageId;
          _this2.originalFuConfig = fuConfig;
          if (fuConfig) {
            try {
              var configData = typeof fuConfig === 'string' ? JSON.parse(fuConfig) : fuConfig;
              if (configData && configData.allocations && Array.isArray(configData.allocations)) {
                var cacheData = {};
                configData.allocations.forEach(function (allocation) {
                  if (allocation.cardId && allocation.beans) {
                    cacheData[allocation.cardId] = allocation.beans;
                  }
                });
                _this2.packageDistributionCache[fuPackageId] = cacheData;
              }
            } catch (error) {
              console.error('解析福卡配置失败', error);
            }
          }
          _this2.getRelatedCards(fuPackageId);
          _this2.loadPackageDetails(fuPackageId);
        }
        _this2.details = _objectSpread({}, _this2.pram);

        // 无论订单类型如何，都加载优惠券包数据
        if (processedCouponPackages && processedCouponPackages.length > 0) {
          _this2.loadCouponPackageDetails(processedCouponPackages);
        }
        _this2.initloading = false;
      });
    },
    // 获取小程序列表
    getAppList: function () {
      var _getAppList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return (0, _cardDetailApi.getMiniappList)();
            case 1:
              res = _context.v;
              if (res && Array.isArray(res)) {
                // 保留小程序与归属客户的关联信息，方便后续联动归属客户
                this.appOptions = res.map(function (item) {
                  return {
                    id: item.id,
                    name: item.appName,
                    customerId: item.customerId,
                    customerName: item.customerName || item.customer_name || item.customer || '',
                    companyId: item.companyId || ''
                  };
                });
              }
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              this.$message.error('获取小程序列表失败');
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function getAppList() {
        return _getAppList.apply(this, arguments);
      }
      return getAppList;
    }(),
    // 进入页面初始搜索
    initAll: function initAll() {
      this.searchMeals();
      this.searchCusotmer();
      this.fetchCompanyList('');
    },
    // 发放小程序变更时，联动更新归属客户
    handleAppChange: function handleAppChange(appId) {
      if (!appId) {
        this.pram.customerId = '';
        // 清空归属客户选项，保持禁用状态下的展示干净
        this.cosotmerOption = [];
        return;
      }
      var app = this.appOptions.find(function (item) {
        return item.id === appId;
      });
      if (!app || !app.customerId) {
        return;
      }
      console.log("app>>>>>>>>>>", app);
      // 设置表单中的归属客户 ID
      this.pram.customerId = app.customerId;

      // 同步更新下拉选项，只保留当前小程序对应的归属客户
      this.cosotmerOption = [{
        id: app.customerId,
        name: app.name || "\u5BA2\u6237".concat(app.name, " ").concat(app.customerId)
      }];
    },
    // 归属公司搜索
    handleCompanySearch: function handleCompanySearch(val) {
      var _this3 = this;
      this.throttle(function () {
        _this3.fetchCompanyList(val);
      }, 300)();
    },
    // 拉取归属公司列表
    fetchCompanyList: function () {
      var _fetchCompanyList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var key,
          presetId,
          res,
          _args2 = arguments,
          _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              key = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : '';
              presetId = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : '';
              _context2.p = 1;
              _context2.n = 2;
              return suplierCouponsApi.getAllCompany(key);
            case 2:
              res = _context2.v;
              this.companyOptions = res || [];
              // 如果传入了预选ID且列表包含该ID，则不动；如果不包含则补充
              if (presetId && !this.companyOptions.some(function (item) {
                return "".concat(item.id) === "".concat(presetId);
              })) {
                // 尝试用已有数据补充一条占位
                this.companyOptions = [{
                  id: presetId,
                  name: presetId
                }].concat(_toConsumableArray(this.companyOptions));
              }
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t2 = _context2.v;
              this.$message.error('获取公司列表失败');
            case 4:
              return _context2.a(2);
          }
        }, _callee2, this, [[1, 3]]);
      }));
      function fetchCompanyList() {
        return _fetchCompanyList.apply(this, arguments);
      }
      return fetchCompanyList;
    }(),
    // 更新福卡有效期时间范围
    updateCardTimeRange: function updateCardTimeRange(val) {
      if (val && val.length === 2) {
        this.pram.cardValidStart = val[0];
        this.pram.cardValidEnd = val[1];
      } else {
        this.pram.cardValidStart = '';
        this.pram.cardValidEnd = '';
      }
    },
    // 将福卡有效期默认设置为：当前时间起 3 年
    setDefaultCardTimeRange: function setDefaultCardTimeRange() {
      var pad = function pad(n) {
        return n < 10 ? '0' + n : n;
      };
      var format = function format(date) {
        var y = date.getFullYear();
        var m = pad(date.getMonth() + 1);
        var d = pad(date.getDate());
        var hh = pad(date.getHours());
        var mm = pad(date.getMinutes());
        var ss = pad(date.getSeconds());
        return "".concat(y, "-").concat(m, "-").concat(d, " ").concat(hh, ":").concat(mm, ":").concat(ss);
      };
      var now = new Date();
      var end = new Date(now);
      end.setFullYear(end.getFullYear() + 3);
      var startStr = format(now);
      var endStr = format(end);
      this.pram.cardTimeRange = [startStr, endStr];
      this.pram.cardValidStart = startStr;
      this.pram.cardValidEnd = endStr;
    },
    // 计算订单总金额 & 销售总价
    calculateTotalPrice: function calculateTotalPrice() {
      // 原有：根据福卡面值 price 和数量 quantity 计算订单总金额 totalPrice
      if (this.pram.type !== 3 && this.pram.price && this.pram.quantity) {
        // 单价 × 数量 = 总金额（仅适用于非权益卡包类型）
        this.pram.totalPrice = parseFloat((this.pram.price * this.pram.quantity).toFixed(2));
      } else if (this.pram.type === 3) {
        // 权益卡包类型，总金额等于数量×面值
        this.pram.totalPrice = parseFloat((this.pram.price * this.pram.quantity).toFixed(2));

        // 如果有关联卡片并且改变了面值，自动分配面值
        if (this.relatedCards.length > 0) {
          this.distributeValueEvenly();
        }
      }
    },
    handerSubmit: (0, _validate.Debounce)(function (form) {
      var _this4 = this;
      this.$refs[form].validate(function (valid) {
        if (!valid) return;

        // 准备提交数据
        var submitData = {
          orderNo: _this4.orderNo,
          type: _this4.pram.type,
          orderName: _this4.pram.orderName,
          sendType: _this4.pram.sendType,
          appId: _this4.pram.appId,
          customerId: _this4.pram.customerId,
          quantity: _this4.pram.quantity,
          totalPrice: _this4.pram.totalPrice,
          salesUnitPrice: _this4.pram.salesUnitPrice,
          price: _this4.pram.price,
          salesPrice: _this4.pram.salesPrice,
          // Add salesPrice to submission data
          status: _this4.pram.status,
          remark: _this4.pram.remark,
          companyId: _this4.pram.companyId,
          innerRemark: _this4.pram.innerRemark,
          kamiType: _this4.pram.kamiType,
          innerCompanyName: _this4.pram.innerCompanyName,
          // 优惠券包ID列表 - 确保所有订单类型都有这个字段
          couponPackages: _this4.pram.couponPackages && _this4.pram.couponPackages.length > 0 ? _this4.pram.couponPackages : [],
          // 新的福卡有效期字段 - 确保所有类型都提交
          cardValidStart: _this4.pram.cardValidStart || _this4.pram.cardTimeRange && _this4.pram.cardTimeRange[0],
          cardValidEnd: _this4.pram.cardValidEnd || _this4.pram.cardTimeRange && _this4.pram.cardTimeRange[1],
          // 新的订单有效期字段
          orderValidStart: _this4.pram.orderValidStart || _this4.pram.orderTimeRange && _this4.pram.orderTimeRange[0],
          orderValidEnd: _this4.pram.orderValidEnd || _this4.pram.orderTimeRange && _this4.pram.orderTimeRange[1],
          // 始终添加项目编号
          projectNumber: _this4.pram.projectNumber || ''
        };

        // 处理公司 - 确保innerCompanyName字段被正确提交
        submitData.innerCompanyName = _this4.pram.innerCompanyName || '';

        // 调试日志 - 检查innerCompanyName字段
        console.log('提交时的innerCompanyName值:', _this4.pram.innerCompanyName);
        console.log('submitData中的innerCompanyName值:', submitData.innerCompanyName);

        // 编辑模式下，添加id字段
        if (_this4.orderNo) {
          submitData.id = _this4.orderNo; // 确保编辑时传递id字段
        }

        // 兼容旧的API，保留旧字段（如果后端仍然需要）
        if (_this4.pram.orderTimeRange && _this4.pram.orderTimeRange.length === 2) {
          submitData.startTime = _this4.pram.orderTimeRange[0];
          submitData.endTime = _this4.pram.orderTimeRange[1];
        }

        // 权益卡包类型，添加专属字段
        if (_this4.pram.type === 3) {
          // 验证分配额度
          if (_this4.totalDistribution !== parseInt(_this4.pram.price)) {
            if (_this4.totalDistribution > _this4.pram.price) {
              _this4.$message.error("\u5206\u914D\u989D\u5EA6\u603B\u548C\u8D85\u8FC7\u4E86\u798F\u5361\u9762\u503C (\u8D85\u51FA ".concat(_this4.totalDistribution - _this4.pram.price, " \u798F\u8C46)"));
            } else {
              _this4.$message.error("\u5206\u914D\u989D\u5EA6\u603B\u548C\u5C0F\u4E8E\u798F\u5361\u9762\u503C (\u8FD8\u5DEE ".concat(_this4.pram.price - _this4.totalDistribution, " \u798F\u8C46)"));
            }
            return;
          }
          if (_this4.totalDistribution === 0) {
            _this4.$message.error('请至少分配一个卡片的额度');
            return;
          }

          // 确保福卡面值已填写且大于0
          if (!_this4.pram.price || _this4.pram.price <= 0) {
            _this4.$message.error('请设置福卡面值且大于0');
            return;
          }

          // 确保一定有packageId
          if (!_this4.pram.packageId) {
            _this4.$message.error('请选择权益卡包');
            return;
          }

          // 添加 fuPackageId 字段 - 确保一定会传
          submitData.fuPackageId = _this4.pram.packageId;

          // 构建 fuConfig 字段
          var allocations = _this4.relatedCards.filter(function (card) {
            return card.distributionValue > 0;
          }).map(function (card) {
            return {
              cardId: card.id,
              cardName: card.cardName || '卡片名称',
              beans: card.distributionValue
            };
          });

          // 确保一定会传fuConfig，即使allocations为空
          submitData.fuConfig = JSON.stringify({
            allocations: allocations.length ? allocations : []
          });

          // 调试日志 - 检查数据
          console.log('提交权益卡包数据:', JSON.stringify(submitData));
        } else {
          // 其他类型需要传卡片ID
          submitData.fuCardId = _this4.pram.fuCardId;

          // 类型1还需要传套餐ID
          if (_this4.pram.type === 1) {
            submitData.comboId = _this4.pram.comboId;
          }
        }

        // 验证福卡有效期 - 确保所有类型都验证
        if (!submitData.cardValidStart || !submitData.cardValidEnd) {
          _this4.$message.error('请设置福卡有效期');
          return;
        }

        // 验证订单有效期
        if (!submitData.orderValidStart || !submitData.orderValidEnd) {
          _this4.$message.error('请设置订单有效期');
          return;
        }

        // 类型2的特殊处理
        if (_this4.pram.type === 2) {
          // 移除dueTime，统一使用cardValidEnd
          submitData.dueTime = submitData.cardValidEnd;
        }
        ;

        // 这部分已经在初始化submitData时处理了
        // console.log('已设置的券包ID列表:', submitData.couponPackages);

        // // 记录项目编号和公司信息
        // console.log('项目编号:', submitData.projectNumber || '未设置');
        // console.log('公司ID:', submitData.innerCompanyName || '未设置');
        // console.log('公司名称:', submitData.companyName || '未设置');

        _this4.loading = true;
        // console.log('最终提交数据:', JSON.stringify(submitData));

        // 添加编辑模式的调试信息
        if (_this4.orderNo) {
          // console.log('编辑模式 - 订单ID:', this.orderNo);
          // console.log('编辑模式 - 项目编号:', submitData.projectNumber);
          console.log('公司名称:', submitData.innerCompanyName || '未设置');
        }
        console.log('最终提交数据:', submitData);
        customerOrderApi[_this4.orderNo ? 'UpdateArticle' : 'AddArticle'](submitData).then(function (data) {
          _this4.$message.success('操作成功');
          _this4.loading = false;
          _this4.visible = false;
          _this4.$emit('doRefresh');
        }).catch(function (err) {
          console.error('提交失败:', err);
          _this4.loading = false;
        });
      });
    }),
    closeEdit: function closeEdit() {
      this.visible = false;
    },
    // 处理公司选择
    selectCompany: function selectCompany(value) {
      this.pram.companyId = value;
      var _ref2 = value && value.split('_') || [],
        _ref3 = _slicedToArray(_ref2, 2),
        id = _ref3[0],
        name = _ref3[1];
      if (id) {
        this.searchCusotmer(id);
        this.searchMeals({
          companyId: id
        });
      }
    },
    // 归属客户
    searchCusotmer: function searchCusotmer(companyId) {
      var _this5 = this;
      this.cosotmerOption = [];
      customerOrderApi.getAllCustomer({
        companyId: companyId
      }).then(function (res) {
        _this5.cosotmerOption = res || [];
      });
    },
    // 获取套餐
    searchMeals: function searchMeals(data) {
      var _this6 = this;
      customerOrderApi.getComboList(data).then(function (res) {
        _this6.mealOption = res.map(function (item) {
          var _ref4 = item || {},
            price = _ref4.price,
            name = _ref4.name,
            id = _ref4.id;
          return {
            price: price,
            name: name,
            id: "".concat(id, "_").concat(name)
          };
        });
      });
    },
    // 搜索套餐
    handleMealSearch: function handleMealSearch(keyword) {
      var _this7 = this;
      this.throttle(function () {
        _this7.searchMeals({
          keyword: keyword
        });
      }, 300)();
    },
    // 选择套餐，将套餐金额填入
    selectMeals: function selectMeals(id) {
      var idx = this.mealOption.findIndex(function (item) {
        return item.id == id;
      });
      if (idx == -1) {
        this.$set(this.pram, 'price', 0);
        this.searchMeals('');
        return;
      }
      ;
      this.$set(this.pram, 'price', this.mealOption[idx].price || 0);
      // 更新计算总金额
      this.calculateTotalPrice();
    },
    searchBrand: function searchBrand() {
      var _this8 = this;
      var keyword = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      this.brandOption = [];
      var _ref5 = this.pram || {},
        type = _ref5.type;
      fudouActiveApi.selectCard(keyword, Boolean(type == 1)).then(function (res) {
        _this8.brandOption = res || [];
      });
    },
    handleAgreementSearch: function handleAgreementSearch(data) {
      var _this9 = this;
      this.throttle(function () {
        _this9.searchBrand(data);
      }, 300)();
    },
    changeBrand: function changeBrand() {
      var _this$pram;
      if (!((_this$pram = this.pram) !== null && _this$pram !== void 0 && _this$pram.brandId)) {
        this.searchBrand('');
      }
      ;
    },
    changeTypeSelect: function changeTypeSelect() {
      // 清空相关字段
      this.$set(this.pram, 'fuCardId', null);
      this.$set(this.pram, 'packageId', null);
      this.$set(this.pram, 'comboId', null);
      this.$set(this.pram, 'price', null);
      // 不再清空优惠券包选择
      // this.$set(this.pram, 'couponPackages', []);

      // 根据类型加载不同数据
      switch (this.pram.type) {
        case 1:
          // 用户自选
          this.searchMeals('');
          this.searchBrand('');
          break;
        case 2:
          // 福卡充值
          this.searchBrand('');
          break;
        case 3:
          // 权益卡包
          this.searchPackages(true);
          this.relatedCards = [];
          this.totalDistribution = 0;
          break;
      }

      // 所有类型都加载优惠券包
      this.searchCouponPackages(true);
    },
    // 搜索权益卡包
    searchPackages: function searchPackages() {
      var _this0 = this;
      var refresh = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var callback = arguments.length > 1 ? arguments[1] : undefined;
      if (refresh) {
        this.packagePage = 1;
        this.packageOptions = [];
      }
      var params = {
        page: this.packagePage,
        limit: this.packageLimit,
        keyword: this.packageKeyword,
        status: 1
      };
      this.loading = true;

      // 调用API获取卡包列表
      customerOrderApi.getCardPackageList(params).then(function (res) {
        var _ref6 = res || {
            list: [],
            total: 0
          },
          list = _ref6.list,
          total = _ref6.total;
        if (refresh) {
          _this0.packageOptions = list;
        } else {
          _this0.packageOptions = [].concat(_toConsumableArray(_this0.packageOptions), _toConsumableArray(list));
        }

        // 判断是否还有更多数据
        _this0.hasMorePackages = _this0.packageOptions.length < total;
        _this0.loading = false;

        // 执行回调
        if (typeof callback === 'function') {
          callback();
        }
      }).catch(function () {
        _this0.loading = false;

        // 即使出错也执行回调
        if (typeof callback === 'function') {
          callback();
        }
      });
    },
    // 处理权益卡包搜索
    handlePackageSearch: function handlePackageSearch(keyword) {
      var _this1 = this;
      this.packageKeyword = keyword;
      this.throttle(function () {
        _this1.searchPackages(true);
      }, 300)();
    },
    // 加载更多权益卡包
    loadMorePackages: function loadMorePackages(callback) {
      this.packagePage += 1;
      this.searchPackages(false, callback);
    },
    // 选择权益卡包
    selectPackage: function selectPackage(packageId) {
      if (!packageId) {
        this.relatedCards = [];
        this.totalDistribution = 0;
        return;
      }

      // 先保存当前配置到缓存
      if (this.pram.packageId && this.relatedCards.length > 0) {
        var currentDistribution = {};
        this.relatedCards.forEach(function (card) {
          if (card.distributionValue > 0) {
            currentDistribution[card.id] = card.distributionValue;
          }
        });

        // 只有在有分配数据时才缓存
        if (Object.keys(currentDistribution).length > 0) {
          this.packageDistributionCache[this.pram.packageId] = currentDistribution;
        }
      }

      // 设置新的卡包ID
      this.pram.packageId = packageId;
      this.pram.fuPackageId = packageId;

      // 获取关联的卡片，应用缓存配置
      this.getRelatedCards(packageId);
    },
    // 获取关联的卡片
    getRelatedCards: function getRelatedCards(packageId, callback) {
      var _this10 = this;
      this.loading = true;

      // 调用API获取关联的卡片
      customerOrderApi.getRelatedCards(packageId).then(function (res) {
        if (res && Array.isArray(res)) {
          // 获取当前卡包的缓存配置
          var cachedDistribution = _this10.packageDistributionCache[packageId] || {};

          // 为每个卡片添加分配额度属性，优先使用缓存值
          _this10.relatedCards = res.map(function (card) {
            return _objectSpread(_objectSpread({}, card), {}, {
              distributionValue: cachedDistribution[card.id] || 0
            });
          });

          // 如果已经有福卡面值，自动分配
          if (_this10.pram.price && parseInt(_this10.pram.price) > 0) {
            _this10.distributeValueEvenly();
          }
        } else {
          _this10.relatedCards = [];
        }
        _this10.updateTotalDistribution();
        _this10.loading = false;

        // 如果提供了回调函数，执行它
        if (typeof callback === 'function') {
          callback();
        }
      }).catch(function () {
        _this10.relatedCards = [];
        _this10.loading = false;
      });
    },
    // 更新总分配额度
    updateTotalDistribution: function updateTotalDistribution() {
      this.totalDistribution = this.relatedCards.reduce(function (sum, card) {
        return sum + (parseInt(card.distributionValue) || 0);
      }, 0);

      // 更新当前卡包的缓存
      if (this.pram.packageId) {
        var currentDistribution = {};
        this.relatedCards.forEach(function (card) {
          if (card.distributionValue > 0) {
            currentDistribution[card.id] = card.distributionValue;
          }
        });

        // 更新缓存
        this.packageDistributionCache[this.pram.packageId] = currentDistribution;
      }
    },
    // 添加方法加载权益卡包详情
    loadPackageDetails: function loadPackageDetails(packageId) {
      var _this11 = this;
      if (!packageId) return;

      // 首先尝试搜索卡包列表，以便在下拉列表中显示
      this.searchPackages(true, function () {
        // 检查是否已经在列表中有该卡包
        var packageIndex = _this11.packageOptions.findIndex(function (item) {
          return item.id === packageId;
        });

        // 如果卡包不在当前列表中，需要单独获取卡包详情
        if (packageIndex === -1) {
          _this11.loadMorePackages(function () {
            // 再次检查是否在扩展列表中
            var extendedPackageIndex = _this11.packageOptions.findIndex(function (item) {
              return item.id === packageId;
            });

            // 如果扩展列表中也没有，单独获取卡包详情
            if (extendedPackageIndex === -1) {
              _this11.loadSinglePackageDetail(packageId);
            }
          });
        }
      });
    },
    // 获取单个卡包详情
    loadSinglePackageDetail: function loadSinglePackageDetail(packageId) {
      var _this12 = this;
      // 使用API获取卡包详情
      customerOrderApi.getCardPackageDetail(packageId).then(function (res) {
        if (res && res.id) {
          // 如果卡包不在列表中，添加到列表首位
          var exists = _this12.packageOptions.some(function (item) {
            return item.id === res.id;
          });
          if (!exists) {
            _this12.packageOptions.unshift({
              id: res.id,
              name: res.name || "\u5361\u5305".concat(res.id)
            });
          }
        }
      }).catch(function (err) {
        console.error('获取卡包详情失败', err);
      });
    },
    // 获取优惠券包列表
    searchCouponPackages: function searchCouponPackages() {
      var _this13 = this;
      var refresh = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var initialSelectedIds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      if (refresh) {
        this.couponPackagePage = 1;
        this.couponPackageOptions = [];
      }
      this.couponPackageLoading = true;

      // 构建请求参数
      var params = {
        page: this.couponPackagePage,
        limit: this.couponPackageLimit,
        // 使用limit而不是pageSize
        packageName: this.couponPackageKeyword // 使用packageName作为参数名称
      };

      // 如果有初始选择的IDs，添加到请求中
      if (initialSelectedIds && initialSelectedIds.length > 0) {
        console.log('正在加载初始选择的优惠券包IDs:', initialSelectedIds);
      }

      // 调用API获取优惠券包列表
      (0, _api.couponPackageListApi)(params).then(function (res) {
        // 从res.data中获取数据
        var _ref7 = res || {
            list: [],
            total: 0
          },
          list = _ref7.list,
          total = _ref7.total;
        console.log('获取到的优惠券包数据:', list);

        // 确保每个couponPackage都有唯一的id
        var processedList = (list || []).map(function (item) {
          // 确保有id字段，如果没有则使用其他唯一标识符
          if (!item.id && item.packageId) {
            item.id = item.packageId;
          } else if (!item.id) {
            // 如果既没有id也没有packageId，使用packageName作为备选
            // 但这并不理想，所以添加警告
            console.warn('券包缺少唯一ID:', item);
            item.id = "pkg_".concat(item.packageName);
          }
          return item;
        });
        if (refresh) {
          _this13.couponPackageOptions = processedList;
        } else {
          _this13.couponPackageOptions = [].concat(_toConsumableArray(_this13.couponPackageOptions), _toConsumableArray(processedList));
        }

        // 调试：查看选项是否有重复ID
        var idCounts = {};
        _this13.couponPackageOptions.forEach(function (item) {
          idCounts[item.id] = (idCounts[item.id] || 0) + 1;
        });
        var duplicates = Object.entries(idCounts).filter(function (_ref8) {
          var _ref9 = _slicedToArray(_ref8, 2),
            id = _ref9[0],
            count = _ref9[1];
          return count > 1;
        });
        if (duplicates.length > 0) {
          console.error('发现重复的券包ID:', duplicates);
        }
        _this13.couponPackageTotal = total;
        _this13.couponPackageLoading = false;

        // 如果有初始选择的IDs，尝试加载对应的券包信息
        if (initialSelectedIds && initialSelectedIds.length > 0) {
          _this13.loadMissingCouponPackages(initialSelectedIds);
        }
      }).catch(function (err) {
        console.error('获取优惠券包列表失败', err);
        _this13.couponPackageLoading = false;
      });
    },
    // 加载缺失的优惠券包详情
    loadMissingCouponPackages: function loadMissingCouponPackages(selectedIds) {
      var _this14 = this;
      if (!selectedIds || !selectedIds.length) return;
      var missingIds = selectedIds.filter(function (id) {
        return !_this14.couponPackageOptions.some(function (option) {
          return option.id == id;
        });
      });
      if (missingIds.length === 0) {
        console.log('所有选中的优惠券包已在列表中');
        return;
      }
      console.log('需要加载缺失的优惠券包:', missingIds);

      // 对每个缺失的ID单独获取详情
      Promise.all(missingIds.map(function (id) {
        return _this14.getCouponPackageById(id);
      })).then(function (packages) {
        var validPackages = packages.filter(Boolean);
        if (validPackages.length) {
          console.log('成功加载缺失的优惠券包:', validPackages);
          _this14.couponPackageOptions = [].concat(_toConsumableArray(_this14.couponPackageOptions), _toConsumableArray(validPackages));
        }
      });
    },
    // 根据ID获取优惠券包详情
    getCouponPackageById: function getCouponPackageById(id) {
      var _this15 = this;
      return new Promise(function (resolve, reject) {
        (0, _api.couponPackageListApi)({
          id: id
        }).then(function (res) {
          if (res && res.list && res.list.length) {
            // 找到匹配的包
            var matchingPackage = res.list.find(function (pkg) {
              return pkg.id == id;
            });
            if (matchingPackage) {
              resolve(matchingPackage);
              return;
            }
          }

          // 如果没有找到，尝试直接获取详情
          _this15.getSingleCouponPackage(id).then(function (pkg) {
            resolve(pkg);
          }).catch(function (err) {
            console.error("\u83B7\u53D6\u5238\u5305\u8BE6\u60C5\u5931\u8D25\uFF1A".concat(id), err);
            reject(err);
          });
        }).catch(function (err) {
          // 列表请求失败，尝试单个获取
          _this15.getSingleCouponPackage(id).then(function (pkg) {
            resolve(pkg);
          }).catch(function (err) {
            console.error("\u83B7\u53D6\u5238\u5305\u8BE6\u60C5\u5931\u8D25\uFF1A".concat(id), err);
            reject(err);
          });
        });
      });
    },
    // 获取单个优惠券包详情
    getSingleCouponPackage: function getSingleCouponPackage(id) {
      return new Promise(function (resolve, reject) {
        if (!id) {
          reject('无效的ID');
          return;
        }

        // 使用详情API
        (0, _api.couponPackageDetailApi)(id).then(function (res) {
          if (res) {
            var _res$coupons;
            // 构造一个与列表项结构一致的对象
            var packageItem = {
              id: res.id,
              packageId: res.id,
              packageName: res.name || "\u5238\u5305".concat(id),
              couponCount: ((_res$coupons = res.coupons) === null || _res$coupons === void 0 ? void 0 : _res$coupons.length) || 0
            };
            console.log("\u6210\u529F\u83B7\u53D6\u5238\u5305".concat(id, "\u8BE6\u60C5:"), packageItem);
            resolve(packageItem);
          } else {
            reject('返回数据为空');
          }
        }).catch(function (err) {
          reject(err);
        });
      });
    },
    // 加载优惠券包详情 - 新增此方法
    loadCouponPackageDetails: function loadCouponPackageDetails(packageIds) {
      var _this16 = this;
      if (!packageIds || !packageIds.length) {
        console.log('没有需要加载的优惠券包');
        return;
      }
      console.log('正在加载优惠券包详情:', packageIds);
      this.couponPackageLoading = true;

      // 先检查当前已有的选项中是否包含这些ID
      var existingIds = this.couponPackageOptions.map(function (item) {
        return item.id;
      });
      var missingIds = packageIds.filter(function (id) {
        return !existingIds.includes(id);
      });

      // 如果所有ID都已存在，就不需要额外加载
      if (missingIds.length === 0) {
        console.log('所有优惠券包已在选项中');
        this.couponPackageLoading = false;
        return;
      }

      // 先尝试加载列表，看能否一次性获取所有包
      this.searchCouponPackages(true, function () {
        // 检查加载列表后是否还有缺失的包
        _this16.loadMissingCouponPackages(packageIds);
        _this16.couponPackageLoading = false;
      });
    },
    // 处理优惠券包搜索
    handleCouponPackageSearch: function handleCouponPackageSearch(keyword) {
      var _this17 = this;
      this.couponPackageKeyword = keyword;
      this.throttle(function () {
        // 如果有关键字并且选项中已经有结果，先尝试本地过滤
        if (keyword && _this17.couponPackageOptions.length > 0) {
          // 先过滤本地选项，看是否有匹配的
          var filtered = _this17.couponPackageOptions.filter(function (item) {
            return item.packageName && item.packageName.toLowerCase().includes(keyword.toLowerCase());
          });
          // 如果本地有匹配项，不发送请求
          if (filtered.length > 0) {
            console.log('本地过滤匹配', keyword, filtered.length);
            return;
          }
        }
        _this17.searchCouponPackages(true);
      }, 300)();
    },
    // 加载更多优惠券包
    loadMoreCouponPackages: function loadMoreCouponPackages() {
      this.couponPackagePage += 1;
      this.searchCouponPackages(false);
    },
    // 处理优惠券包选择变更
    handleCouponPackagesChange: function handleCouponPackagesChange(selected) {
      // value是元素的:value值，即couponPackageOptions中设置的item.id
      console.log('选择的优惠券包ID:', selected, '(确认这是ID而非名称)');

      // 确保值是唯一的且为数字类型
      var uniqueValues = _toConsumableArray(new Set(selected)).map(function (id) {
        return typeof id === 'string' ? parseInt(id, 10) : id;
      }).filter(Boolean);
      if (uniqueValues.length !== selected.length) {
        console.warn('去重前:', selected, '去重后:', uniqueValues);
      }

      // 保存ID到表单数据
      this.pram.couponPackages = uniqueValues;
    },
    // 添加恢复原始配置的方法
    restoreOriginalConfig: function restoreOriginalConfig() {
      var _this18 = this;
      if (this.originalPackageId && this.originalFuConfig) {
        // 选择原始卡包
        this.pram.packageId = this.originalPackageId;
        this.pram.fuPackageId = this.originalPackageId;

        // 解析原始配置
        try {
          var configData = typeof this.originalFuConfig === 'string' ? JSON.parse(this.originalFuConfig) : this.originalFuConfig;
          if (configData && configData.allocations && Array.isArray(configData.allocations)) {
            // 获取卡片列表并应用原始配置
            this.getRelatedCards(this.originalPackageId, function () {
              // 应用原始分配值
              configData.allocations.forEach(function (allocation) {
                var cardIndex = _this18.relatedCards.findIndex(function (card) {
                  return card.id === allocation.cardId;
                });
                if (cardIndex >= 0) {
                  // 设置分配值
                  _this18.$set(_this18.relatedCards[cardIndex], 'distributionValue', allocation.beans || 0);
                }
              });

              // 更新总分配额度
              _this18.updateTotalDistribution();
            });
          }
        } catch (error) {
          console.error('恢复原始配置失败', error);
        }
      }
    },
    // 添加更新订单有效期时间范围方法
    updateOrderTimeRange: function updateOrderTimeRange(val) {
      if (val && val.length === 2) {
        this.pram.orderValidStart = val[0];
        this.pram.orderValidEnd = val[1];
      } else {
        this.pram.orderValidStart = '';
        this.pram.orderValidEnd = '';
      }
    },
    // 添加自动分配福卡面值的方法
    distributeValueEvenly: function distributeValueEvenly() {
      var totalValue = parseInt(this.pram.price) || 0;
      var cardCount = this.relatedCards.length;
      if (cardCount === 0 || totalValue === 0) return;

      // 计算基础分配值和余数
      var baseValue = Math.floor(totalValue / cardCount);
      var remainder = totalValue % cardCount;

      // 分配给每张卡
      this.relatedCards.forEach(function (card, index) {
        card.distributionValue = baseValue;
        // 将余数依次+1分配给前面的卡片
        if (remainder > 0) {
          card.distributionValue += 1;
          remainder--;
        }
      });
      this.updateTotalDistribution();
    },
    // 更新分配值并计算总和
    updateDistributionValue: function updateDistributionValue(card, value) {
      // 更新当前卡的分配值
      card.distributionValue = parseFloat(value) || 0;

      // 重新计算总分配值
      this.totalDistribution = this.relatedCards.reduce(function (sum, card) {
        return sum + (parseFloat(card.distributionValue) || 0);
      }, 0);

      // 检查分配总额是否等于福卡面值
      this.distributionWarningVisible = this.totalDistribution !== parseFloat(this.pram.price);
    },
    // 添加处理优惠券包的逻辑
    processCouponPackages: function processCouponPackages(couponPackages) {
      if (Array.isArray(couponPackages)) {
        return couponPackages.map(function (id) {
          return typeof id === 'string' ? parseInt(id) : id;
        }).filter(Boolean);
      } else if (typeof couponPackages === 'string') {
        return [parseInt(couponPackages)];
      } else {
        console.error('无效的优惠券包格式');
        return [];
      }
    }
  }
};